import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const FamilyConcernsSection = ({
  sessionFormData,
  updateFormData,
  handleSupportSystemChange,
  livingSituationError,
  supportSystemError,
  setLivingSituationError,
  setSupportSystemError,
  autoResizeTextarea
}) => {
  const livingSituationOptions = [
    "Lives alone",
    "Lives with partner/spouse",
    "Lives with parents/family",
    "Lives with children/dependents",
    "Shared housing/roommates",
    "Supported housing/group home",
    "Assisted living/nursing facility",
    "Homeless/unstable housing"
  ];

  const supportSystemOptions = [
    "Partner/spouse",
    "Parents/family",
    "Children/extended family",
    "Friends/peers",
    "Faith/spiritual community",
    "Community/volunteer organizations",
    "Mental health providers/care team",
    "Case manager/social worker",
    "No consistent supports",
    "Other"
  ];

  return (
    <Card id="family-social" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Family & Social History
      </h3>

      <div style={{ marginBottom: "24px" }}>
        <label className={styles.labelWithMarginLarge}>
          Living Situation
        </label>
        {livingSituationError && (
          <div className={styles.errorMessage}>
            {livingSituationError}
          </div>
        )}
        <div className={styles.radioContainer}>
          {livingSituationOptions.map((option) => (
            <div key={option} className={styles.radioItem}>
              <input
                type="radio"
                id={`living-${option}`}
                name="livingSituation"
                value={option}
                checked={sessionFormData.livingSituation === option}
                onChange={(e) => {
                  updateFormData("livingSituation", e.target.value);
                  if (livingSituationError) {
                    setLivingSituationError("");
                  }
                }}
                className={styles.radio}
              />
              <label htmlFor={`living-${option}`} className={styles.checkboxLabel}>
                {option}
              </label>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: "24px" }}>
        <label className={styles.labelWithMarginLarge}>
          Support System
        </label>
        {supportSystemError && (
          <div className={styles.errorMessage}>
            {supportSystemError}
          </div>
        )}
        <div className={styles.radioContainer}>
          {supportSystemOptions.map((option) => {
            const isNoConsistentSelected = sessionFormData.selectedSupportSystem.includes("No consistent supports");
            const isDisabled = isNoConsistentSelected && option !== "No consistent supports";
            const isOtherOption = option === "Other";

            return (
              <div key={option} className={styles.radioItem} style={isOtherOption ? { display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" } : {}}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <input
                    type="checkbox"
                    id={`support-${option}`}
                    checked={sessionFormData.selectedSupportSystem.includes(option)}
                    onChange={() => handleSupportSystemChange(option)}
                    disabled={isDisabled}
                    className={styles.checkbox}
                  />
                  <label
                    htmlFor={`support-${option}`}
                    className={styles.checkboxLabel}
                    style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                  >
                    {option}
                  </label>
                </div>
                {isOtherOption && sessionFormData.selectedSupportSystem.includes("Other") && (
                  <div style={{ fontSize: "12px", color: "#8E8E93", marginLeft: "auto" }}>
                    {sessionFormData.otherSupportSystemText?.length || 0}/100
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {sessionFormData.selectedSupportSystem.includes("Other") && (
          <div style={{ marginTop: "12px" }}>
            <textarea
              id="support-system-other-textarea"
              value={sessionFormData.otherSupportSystemText || ""}
              onChange={(e) => {
                autoResizeTextarea(e.target);
                updateFormData("otherSupportSystemText", e.target.value);
              }}
              placeholder="Please specify."
              className={styles.otherTextInput}
              rows={1}
              style={{ minHeight: "34px", resize: "none", overflow: "hidden" }}
              maxLength={100}
            />
          </div>
        )}
      </div>

      <div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
          <label className={styles.labelWithMargin} style={{ marginBottom: 0 }}>
            Additional Notes
          </label>
          <div style={{ fontSize: "12px", color: "#8E8E93" }}>
            {sessionFormData.familySocialNotes?.length || 0}/400
          </div>
        </div>
        <textarea
          value={sessionFormData.familySocialNotes}
          onChange={(e) => {
            const value = e.target.value;
            if (value.length <= 400) {
              updateFormData("familySocialNotes", value);
            }
          }}
          placeholder="Free Text"
          className={styles.textarea}
          maxLength={400}
        />
      </div>
    </Card>
  );
};

export default FamilyConcernsSection;

